import React, { FC } from "react";

interface SocialLinkProps {
  href: string;
  imgSrc?: string;
}

const SocialLink: FC<SocialLinkProps> = ({ href, imgSrc }) => {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <img height={28} width={28} src={imgSrc} alt="starfarm-social" />
    </a>
  );
};

export default SocialLink;

